import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { DistrictAddSchoolTypeComponent } from "./district-add-school-type/district-add-school-type.component";
import { DistrictEditSchoolTypeComponent } from "./district-edit-school-type/district-edit-school-type.component";
import { DataService_SchoolTypeSetup } from "./shared/data.service";

@Component({
	selector: "app-school-type-setup",
	templateUrl: "./school-type-setup.component.html",
	styleUrls: ["./school-type-setup.component.css"],
})
export class SchoolTypeSetupComponent implements OnInit {
	constructor(
		private userService: UserService,
		private SchoolTypeSetupService: DataService_SchoolTypeSetup,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadSchoolType();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSchoolType: any;
	lstSchoolType: any = [];

	//Filter lists
	lstDefinedByDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "SchoolTypeCD", header: "Code" },
		{ field: "SchoolTypeDesc", header: "Name" },
		// { field: 'DefinedByDesc', header: 'Defined By' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchoolType() {
		this.loading = true;

		var result = this.SchoolTypeSetupService.LoadSchoolType();
		result.subscribe(
			(response) => {
				this.lstSchoolType = response;

				//Load Data Filter Lists
				this.lstDefinedByDesc = Array.from(new Set(this.lstSchoolType.map((item: any) => item.DefinedByDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadSchoolType();
		this.onRowUnselect(null);
	}

	//Custom Button Methods
	onAddType() {
		this.errorMessage = "";

		var ref = this.dialogService.open(DistrictAddSchoolTypeComponent, {
			header: "Add Type",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadSchoolType();
			}
		});
	}

	onEditType() {
		this.errorMessage = "";

		if (this.SelectedSchoolType == undefined) {
			this.errorMessage = "Select a school type to edit";
			return;
		}

		if (this.SelectedSchoolType.DefinedByDesc == "System" || this.SelectedSchoolType.DefinedByDesc == "Import") {
			this.errorMessage = "Cannot edit system-defined or import-defined school types";
			return;
		}

		var ref = this.dialogService.open(DistrictEditSchoolTypeComponent, {
			header: "Edit Type",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SelectedSchoolType: this.SelectedSchoolType,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadSchoolType();
			}
		});
	}

	onDeleteType() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedSchoolType == undefined) {
			this.errorMessage = "Select a school type to delete";
			return;
		}

		if (this.SelectedSchoolType.DefinedByDesc == "System" || this.SelectedSchoolType.DefinedByDesc == "Import") {
			this.errorMessage = "Cannot delete system-defined or import-defined school types";
			return;
		}

		//Call SP
		var result = this.SchoolTypeSetupService.SchoolTypeDeleteInfo(this.SelectedSchoolType.SchoolTypeID);
		result.subscribe(
			(response) => {
				if (response) {
					this.loadSchoolType();
					this.onRowUnselect(null);
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not delete the School Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedSchoolType = val.data;
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedSchoolType = null;
	}
	onRowDblClick(SchoolType) {
		this.errorMessage = "";

		this.SelectedSchoolType = SchoolType;
		this.onEditType();
	}
	////////////////////////////////////////////
}
